export const MODALS_COMMON_GETTER_GET_MODAL_NAME = 'modals_common_getter_get_modal_name'
export const MODALS_COMMON_GETTER_GET_IS_OPEN = 'modals_common_getter_get_is_open'

export const MODALS_COMMON_MUTATION_SET_OPEN = 'modals_common_mutation_set_open'
